import { render } from "./ConfirmOtp.vue?vue&type=template&id=c720cbe4"
import script from "./ConfirmOtp.vue?vue&type=script&lang=js"
export * from "./ConfirmOtp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__